import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { AppContext } from "../../../context/AppContext"
import { getCmsAssetsUrl } from "../../../helpers/general"
import Button from "../../buttons/Button"

import styles from "./ChargerCard.module.scss"

const assetsUrl = getCmsAssetsUrl()

const ChargerCard = ({ charger, compact = false }) => {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const { store } = useContext(AppContext)

  const gotToConfigure = charger => {
    navigate(`/${i18n.language}/configure/${charger.code}`, { state: { from: "menu" } })
  }

  return (
    <div className={compact ? `${styles.chargerContainer} ${styles.compact} charger-${charger.code}` : `${styles.chargerContainer} charger-${charger.code}`}>
      <div className={styles.chargerImageDiv}>
        <div className={styles.halo}></div>
        <img
          className={charger.code === 'rapid60' ? styles.chargerImage60 : charger.code === 'rapid120180' ? styles.chargerImage120180 : charger.code === 'fusion' ? styles.chargerImageFusion : styles.chargerImage}
          src={`${assetsUrl}/${store.initConfig.images}/configuration/${charger.image}`}
          alt={charger.image}
        ></img>
      </div>
      <div className={styles.chargerTextContainer}>
        <div>
          <div className={styles.chargerTitle}>
            {t(`chargers.${charger.code}.title`)}
          </div>
          <div className={styles.chargerSubtitle}>
            {t(`chargers.${charger.code}.subtitle`)}
          </div>
        </div>
        {charger.code === 'rapid60' && 
          <div className={styles.chargerSubtitle}>
            {t(`solo_europa`)}
          </div>
          }
        <div>
          <div className={styles.chargerPower}>
            {t(`chargers.${charger.code}.power`)}
          </div>
          <div className={styles.chargerAction}>
            <Button
              primary={true}
              type="button"
              onClick={() => {
                gotToConfigure(charger)
              }}
            >
              {t("bienvenido.cta")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChargerCard
